<div *ngIf="this.fieldTaskBarData == undefined">
  <div class="row" *ngIf="!this.isReport">
    <div class="col-lg-2">

      <!-- Search Input -->
      <mat-form-field>
        <input matInput type="text" placeholder='{{"Block" | tenantWords}} Name'
          [(ngModel)]="searchString" (keyup.enter)="search()">
        <button  *ngIf="searchString" matSuffix mat-icon-button
          aria-label="Clear"
          (click)="searchString=''; search();">
          <fa-icon [icon]="faTimes"></fa-icon>
          <!-- <mat-icon fontSet="fas" fontIcon="fa-times">close</mat-icon> -->
        </button>
        <button  matSuffix mat-icon-button aria-label="Search"
          (click)="search()">
          <fa-icon [icon]="faSearch"></fa-icon>
          <!-- <mat-icon fontSet="fas" fontIcon="fa-search">search</mat-icon> -->
        </button>
      </mat-form-field>
    </div>

    <!-- Variety Dropdown -->
    <div class="col-lg-2">
      <mat-form-field>
        <mat-label>{{"Variety" | tenantWords}}</mat-label>
        <mat-select [(ngModel)]="selectedVarietyId" name="selectedVarietyId"
          (selectionChange)="search()" [(value)]="selectedVarietyId">
          <mat-option value="0">ALL</mat-option>
          <mat-option *ngFor="let v of varieties" [value]="v.id">
            {{v.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>

    </div>

    <!-- Farm Dropdown -->
    <div class="col-lg-2">
      <mat-form-field>
        <mat-select [(ngModel)]="selectedFarmId" name="selectedFarmId"
          (selectionChange)="search()" [(value)]="selectedFarmId">
          <mat-option value="0">ALL</mat-option>
          <mat-option *ngFor="let f of farms" [value]="f.id">
            {{f.name}}
          </mat-option>
        </mat-select>
        <mat-label>
          {{"Farm" | tenantWords}}
        </mat-label>
      </mat-form-field>
    </div>


    <!-- Inactive Dropdown -->
    <div class="col-lg-2">
      <mat-form-field>
        <mat-label>Include Completed?</mat-label>
        <mat-select [(ngModel)]="includeCompleted"
          name="includeIncompleteDropdown" (selectionChange)="search()"
          [(value)]="includeCompleted">
          <mat-option [value]="true">No</mat-option>
          <mat-option [value]="false">Yes</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="col-lg-4">
      <button style="padding: 0px;" mat-button (click)="generateReport();">
        <fa-icon [icon]="faFileAlt" size="lg"></fa-icon> Export to Excel
      </button>
    </div>

  </div>
</div>


<div class="mat-elevation-z0 row" style="margin-top: 20px;">
  <div class="col-lg-12 col-12">
    <table [nbSpinner]="loading" mat-table class="full-width-table"
    [dataSource]="dataSource" matSort
    aria-label="Elements">

    <!-- Start Date Column -->
    <ng-container matColumnDef="startDate">
      <th class="header" mat-header-cell *matHeaderCellDef mat-sort-header>Start Date</th>
      <td mat-cell *matCellDef="let row">
        <div style="white-space: nowrap;" *ngIf="row.startDate !==
          '1900-01-01T08:00:00Z'">{{row.startDate | date: 'mediumDate'}}</div>
      </td>
    </ng-container>

    <!-- Due Date Column -->
    <ng-container matColumnDef="dueDate">
      <th class="header" mat-header-cell *matHeaderCellDef mat-sort-header>Due Date</th>
      <td style="white-space: nowrap;" mat-cell *matCellDef="let row">
        {{row.dueDate | date:'mediumDate'}}
      </td>
    </ng-container>

    <!-- Assigned Users Column -->
    <ng-container matColumnDef="assignedUsers">
      <th class="header" mat-header-cell *matHeaderCellDef mat-sort-header>Assigned User</th>
      <td mat-cell *matCellDef="let row">{{row.isAllUsers ? 'ALL' :
        row.assignedUsers | assignedUsersPipe}}</td>
    </ng-container>

    <!-- Requested Farms Column -->
    <ng-container matColumnDef="requestedFarms">
      <th class="header" mat-header-cell *matHeaderCellDef mat-sort-header>{{"Farm" | tenantWords}}</th>
      <td mat-cell *matCellDef="let row">
        {{row.requestedFarms}}
      </td>
    </ng-container>

    <!-- Requested Blocks Column -->
    <ng-container matColumnDef="requestedBlocks">
      <th class="header" mat-header-cell *matHeaderCellDef mat-sort-header>{{"Blocks" | tenantWords}}</th>
      <td class="f" smat-cell *matCellDef="let row">
        <kw-popover style="cursor: pointer;" [blocks]="row.requestedBlocks" *ngIf="!this.isReport && row.requestedBlocks.length > 5">
          {{row.requestedBlocks.length}}
        </kw-popover>
        <div *ngIf="row.requestedBlocks.length <= 5 && !this.isReport;" style="margin-top: 10px;">
          <ul *ngFor="let b of row.requestedBlocks">
            <li>
              <div>{{b.name}}, {{b.farmName}} - {{b.varietyName}} </div>
            </li>
          </ul>
        </div>
        <div *ngIf="this.isReport">
          {{row.requestedBlocks.length}}
        </div>
      </td>
    </ng-container>

    <!-- Field Event Type Column -->
    <ng-container matColumnDef="requestedFieldEventType">
      <th class="header" style="white-space:nowrap;" mat-header-cell *matHeaderCellDef
        mat-sort-header>Event Type</th>
      <td mat-cell *matCellDef="let row">{{row.requestedFieldEventType.name}}</td>
    </ng-container>

    <!-- Field Event Type Count -->
    <ng-container matColumnDef="fieldEvents">
      <th class="header" style="white-space:nowrap;" mat-header-cell *matHeaderCellDef
        mat-sort-header>Event Count</th>
      <td mat-cell *matCellDef="let row">{{row.fieldEvents.length}}</td>
    </ng-container>

    <!-- isUserCompleted Column -->
    <ng-container matColumnDef="isUserCompleted">
      <th class="header" mat-header-cell *matHeaderCellDef mat-sort-header>Completed?</th>
      <td mat-cell *matCellDef="let row">
        <div *ngIf="row.isUserCompleted" style="color: green;">
          <fa-icon [icon]="faCheck" class="success"></fa-icon>
        </div>
        <div *ngIf="!row.isUserCompleted" style="color: red;">
          <fa-icon [icon]="faTimes" class="success"></fa-icon>
        </div>
      </td>
    </ng-container>

    <!-- Completed By Column -->
    <ng-container matColumnDef="completedBy">
      <th class="header" style="white-space:nowrap;" mat-header-cell *matHeaderCellDef
        mat-sort-header>Completed By</th>
      <td mat-cell *matCellDef="let row">{{row.completedByUserName}}</td>
    </ng-container>

    <!-- Completed Date Column -->
    <ng-container matColumnDef="completedDate">
      <th class="header" style="white-space:nowrap;" mat-header-cell *matHeaderCellDef
        mat-sort-header>Completed Date</th>
      <td mat-cell *matCellDef="let row">
        <div *ngIf="row.completedDate !== '1900-01-01T08:00:00Z'">{{row.completedDate
          | date:'mediumDate'}}
        </div>
      </td>
    </ng-container>

    <!-- Comments Column -->
    <ng-container matColumnDef="requestorComments">
      <th class="header" mat-header-cell *matHeaderCellDef mat-sort-header>Comment</th>
      <td mat-cell *matCellDef="let row">{{row.requestorComments}}</td>
    </ng-container>

    <!-- view Column -->
    <ng-container matColumnDef="view">
      <th class="header" mat-header-cell *matHeaderCellDef style="padding-left:15px;">View</th>
      <td mat-cell *matCellDef="let row">
        <button mat-button (click)="viewFieldTaskSelected(row);">
          <div>
            <fa-icon [icon]="faEye" size="lg"></fa-icon>
          </div>
        </button>
      </td>
    </ng-container>

    <!-- Edit Column -->
    <ng-container matColumnDef="edit">
      <th class="header" mat-header-cell *matHeaderCellDef style="padding-left:15px;">Edit</th>
      <td mat-cell *matCellDef="let row">
        <button mat-button (click)="editFieldTaskSelected(row);">
          <div *ngIf="!row.isUserCompleted">
            <fa-icon [icon]="faEdit" size="lg"></fa-icon>
          </div>
        </button>
      </td>
    </ng-container>

    <tr class="tableHeader" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  </table>
  </div>

  <mat-paginator style="margin-top: 5px; width: 100%;" #paginator
    [length]="dataSource.data.length" [pageIndex]="0" [pageSize]="100"
    [pageSizeOptions]="[25, 50, 100, 250]"
    [class.hidden]="this.isReport">
  </mat-paginator>


</div>